import { MonitoringKeywordGroupModel } from './monitoring-keyword-group.model';
import { operatorsEnum } from '../enums/operators.enum';

export class RelatedConceptsSearchModel {
    query: string;
    language: string;

    constructor(
        keyworGroup: MonitoringKeywordGroupModel,
        language: string = 'en'
    ) {
        this.query = this.convertKeywordGroupToQuery(keyworGroup);
        this.language = language;
    }

    private convertKeywordGroupToQuery(keyworGroup: MonitoringKeywordGroupModel): string {
        let booleanQuery: string = '';

        const hasAndKeywords: boolean = keyworGroup.and && keyworGroup.and.length > 0;
        const hasOrKeywords: boolean = keyworGroup.or && keyworGroup.or.length > 0;
        const hasNotKeywords: boolean = keyworGroup.not && keyworGroup.not.length > 0;

        if (hasAndKeywords) {
            booleanQuery += this.formatSearchQueryByOperator(keyworGroup.and, operatorsEnum.and);
        }

        if (hasOrKeywords) {
            if (hasAndKeywords) {
                booleanQuery += ` ${operatorsEnum.and} `;
            }

            booleanQuery += this.formatSearchQueryByOperator(keyworGroup.or, operatorsEnum.or);
        }

        if (hasNotKeywords) {
            const notQuery = this.formatSearchQueryByOperator(keyworGroup.not, operatorsEnum.or);

            if (hasAndKeywords && !hasOrKeywords) {
                booleanQuery += ` ${operatorsEnum.not} (${notQuery})`;
            } else if (hasOrKeywords) {
                booleanQuery += ` ${operatorsEnum.and} ${operatorsEnum.not} (${notQuery})`;
            } else {
                booleanQuery += ` ${operatorsEnum.not} (${notQuery})`;
            }
        }

        return booleanQuery;
    }


    /**
     * Gets a boolean query based on the provided keywords
     * formatted to join the keywords with a single operator
     */
    private formatSearchQueryByOperator(keywords: string[], operator: operatorsEnum): string {
        let searchQueryKeywords: string = '';

        keywords.forEach((keyword, index) => {
            const isLast: boolean = index + 1 === keywords.length;

            if (isLast) {
                searchQueryKeywords += `"${keyword}"`;
            } else {
                searchQueryKeywords += `"${keyword}" ${operator} `;
            }
        });

        return searchQueryKeywords;
    }
}
